import { render, staticRenderFns } from "./ExpiredAccounts.vue?vue&type=template&id=519feb3e&scoped=true&"
import script from "./ExpiredAccounts.vue?vue&type=script&lang=js&"
export * from "./ExpiredAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredAccounts.vue?vue&type=style&index=0&id=519feb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519feb3e",
  null
  
)

export default component.exports